import { Link } from 'react-router-dom';
import { FACILITIES } from '../utils/homeData.js';
import { withBasePath } from '../utils/paths.js';

export default function AirportFacilities() {
  return (
    <section className="bg-nkc-mist py-16 sm:py-20" id="facilities">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="v4-reveal mb-10 flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-nkc-gold">Airport facilities</p>
            <h2 className="mt-2 font-display text-3xl font-bold text-nkc-navy sm:text-4xl">
              Comfort between flights
            </h2>
          </div>
          <Link to="/facilities-services" className="text-sm font-bold text-nkc-blue hover:underline">
            Facilities &amp; services →
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5 lg:gap-4">
          {FACILITIES.map((f) => (
            <Link key={f.title} to={f.to} className="v4-reveal v4-zoom group relative overflow-hidden rounded-3xl shadow-soft">
              <img src={withBasePath(f.image)} alt="" className="aspect-[4/5] w-full object-cover" loading="lazy" />
              <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-nkc-navy/90 to-transparent p-4 pt-12">
                <span className="font-display text-sm font-bold text-white">{f.title}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
